export default __webpack_public_path__ + "static/media/misc-pantry3-2048w.190a1e8d.webp";